// extracted by mini-css-extract-plugin
module.exports = {"fontStack":"HtmlSignature_fontStack_3jtpp","signatureWrapper":"HtmlSignature_signatureWrapper_3x4fE"};